import {request} from './request'

const exhibitApi ={
  //列表
  getList:params => request({url: '/TExhibitApi/GetList',params}),

  //单一节目内容
  getOneById: params => request({url: '/TExhibitApi/GetById', params}),
  
  getCateList() {
    return new Promise((resolve, reject) => {
      request({url: '/TExhibitApi/GetTypeIdList'})
        .then((res) => {
          for (let i in res) {
            if (i.indexOf('data') != -1) {
              const list = res[i] || []
              const name = '其他'
              const index = list.findIndex(v => v.name == name)
              if (index != -1) {
                let row = list.find(v => v.name == name)
                row = JSON.parse(JSON.stringify(row))
                list.splice(index, 1)
                list.push(row)
              }
            }
          }
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
}

export default exhibitApi